import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=eed186a8"
import script from "./ContentItem.vue?vue&type=script&lang=ts"
export * from "./ContentItem.vue?vue&type=script&lang=ts"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=eed186a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports